<template>
  <at-modal
    v-model="opened"
    :styles="{ maxWidth: '100vw' }"
    title="Ваш словарик"
  >
    <div
      v-if="selectedTerms.length > 0"
      style="
        border-bottom: 1px solid gray;
        width: 100%;
        font-family: 'Century Gothic', sans-serif;
        font-size: 120%;
      "
    >
      Выбрано {{ wordsCountInformer(selectedTerms.length) }}
    </div>
    <p v-else class="searchitem__body" style="text-align: center">
      Здесь пока ничего нет. Добавляйте слова на карту, и они тут появятся.<br />
      <img src="/static/lang/img/bird.png" class="bird" />
    </p>
    <div class="searchitem__body" v-if="selectedTerms.length > 0">
      <div
        v-for="term in selectedTerms"
        :key="term.id"
        class="searchitem"
        style="padding: 3px; cursor: pointer"
      >
        <i
          class="icon icon-x"
          style="color: red; margin-right: 3px"
          title="Удалить"
          @click="delTermInOwnList(term)"
        />
        <div
          class="own-list-item"
          @click="speech(term)"
          title="Прочитать"
          style="width: 100%"
        >
          {{ term.name }} -
          {{ term.description ? term.description : "..." }}
        </div>
      </div>
    </div>
    <div v-else>&nbsp;</div>
    <div slot="footer">
      <at-button
        type="warning"
        @click="unselectAll"
        v-if="selectedTerms.length > 0"
        >Удалить всё</at-button
      >
      <at-button v-if="selectedTerms.length > 0" @click="download()"
        >Скачать</at-button
      >
      <at-button type="error" @click="opened = false">Закрыть</at-button>
    </div>
  </at-modal>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    // список выбранных слов
    selectedTerms() {
      return this.$store.state.terms.termstack;
    },
  },
  data: () => ({
    opened: true,
  }),
  watch: {
    opened() {
      this.stopSpeech();
      if (!this.opened) this.$router.push({ path: "/" });
    },
  },
  methods: {
    // снятие галочки с термина
    delTermInOwnList(term) {
      term.selected = false;
      // перерисуем точки на карте
      this.$store.dispatch("rePrintPoints");
      // закрываем старое окно с описанием
      this.closenotify();
      // удаляем термин из списка выбранных
      this.$store.commit("delTermFromTermsstack", term);
    },
    // спрягаем слова для информера
    wordsCountInformer(n) {
      var r = n % 10;
      var r1 = n % 100;
      if (r1 > 10 && r1 < 20) return n + " слов";
      if (r == 1) return n + " слово";
      if (r < 5 && r > 1) return n + " слова";
      return n + " слов";
    },
    // очистка списка отложенного
    unselectAll() {
      // снимаем галочки со всех терминов без разбора
      this.$store.state.terms.filter.forEach((term) => {
        term.selected = false;
      });
      // обновляем карту
      this.$store.dispatch("rePrintPoints");
      // очищаем список отложенных терминов
      this.$store.state.terms.termstack = [];
    },
    // закрытие всплывающего окна - информера
    closenotify() {
      this.$store.getters.getNotify.show = false;
    },
    // открытие всплывающего окна - информера
    shownotify(term) {
      this.$store.getters.getNotify.show = true;
      this.$store.getters.getNotify.title = term.name;
      this.$store.getters.getNotify.content = term.description;
    },
    // озвучивание термина + всплывающее уведомление
    async speech(term) {
      // загружаем описание, если не загружено
      if (!term.description) await this.$store.dispatch("getTermDesc", term.id);
      // формируем фразу для озвучивания
      var word = term.name + ", это " + term.description;
      // останавливаем говорилку, если еще говорит
      this.stopSpeech();
      // показываем уведомление
      this.shownotify(term);
      // озвучиваем слово
      speechSynthesis.speak(new SpeechSynthesisUtterance(word));
    },
    // прервать воспроизведение звука и закрыть инфо
    stopSpeech() {
      // закрываем уведомление
      this.closenotify();
      // останавливаем воспроизведение
      speechSynthesis.cancel();
    },
    // скачивает словарик
    download() {
      axios({
        url: "/lang/api/filerender/", //your url
        method: "POST",
        responseType: "blob", // important
        data: { ids: this.selectedTerms.map((term) => term.id) },
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", "file.docx"); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    },
  },
};
</script>

<style scoped>
p,
li {
  text-align: justify;
  font-size: 154% !important;
  font-family: "Century Gothic", sans-serif;
  margin: 6px;
}

b,
i {
  font-family: var(--bs-font-sans-serif);
}

.searchitem {
  font-family: "Century Gothic", sans-serif;
  overflow: hidden;
  height: 24px;
}
.searchitem:hover {
  background-color: rgb(255 204 0 / 19%);
}

.own-list-item {
  font-size: 14px;
  white-space: nowrap;
  max-width: calc(100% - 20px);
  width: 100%;
  display: inline-block;
  direction: ltr;
}

.searchitem__body {
  margin-bottom: 0;
  max-height: 50vh;
  overflow-y: auto;
}

.bird {
  padding: 10px;
  width: 200px;
  filter: brightness(0.25) drop-shadow(rgba(17, 17, 17, 0.4) 2px 2px 2px);
}
</style>